  const mvSwiper = new Swiper('.mv-swiper', {
    loop: true,
    //effect: 'fade',
    slidesPerView: 1,
	spaceBetween: 10,
    centeredSlides: true,
    speed: 1000,
    autoplay: {
      delay: 3000,
      disableOnInteraction: false,
    },
    breakpoints: {
      767: {
        slidesPerView: 1.8,
      }
    },
    /*pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },*/
  });